import { Ticket } from "callable-data-objects";
import React from "react";
import { List, Table } from "semantic-ui-react";
type AssignmentDetailsProps = {
  ticket: Ticket;
};
const AllocationDetails = ({ ticket }: AssignmentDetailsProps) => {
  const { allocationRequest } = ticket;
  const { address, areaCode, qty } = allocationRequest;
  return (
    <Table size='small' padded={false} singleLine basic>
      <Table.Body>
        <Table.Row>
          <Table.Cell>Area Code</Table.Cell>
          <Table.Cell>{areaCode}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Qty</Table.Cell>
          <Table.Cell>{qty}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Address</Table.Cell>
          <Table.Cell>
            <List>
              <List.Item>{address.line1}</List.Item>
              <List.Item>{address.line2}</List.Item>
              <List.Item>{address.level2}</List.Item>
              <List.Item>{address.level1}</List.Item>
              <List.Item>{address.postalCode}</List.Item>
              <List.Item>{address.country}</List.Item>
            </List>
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
};

export default AllocationDetails;
